import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import ArticleDetail from "@/pages/article-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo/guida-completa-itaobuy-spreadsheet",
    element: <Article />,
  },
  {
    path: "/articolo/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;